import { Badge} from "@mui/material";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import { RoleComponentGuard } from "../Reuseables/Guards/RoleComponentGuard";
import DataUsageIcon from "@mui/icons-material/DataUsage";
import { Role, Stage } from "../../types/enums";
import { Project } from "../../types/project";

export default function IconsForProjects({ project }: { project: Project }) {
  if (project.stage === Stage.Preparation) {
    return (
      <>
        <RoleComponentGuard roles={[Role.LocalCoordinator]}>
          <Badge
            badgeContent={!project.readyForReview ? "!" : null}
            color={"info"}
          >
            <AssessmentOutlinedIcon />
          </Badge>
        </RoleComponentGuard>
        <RoleComponentGuard roles={[Role.PrecureAdmin, Role.SolutionOwner, Role.Partner]}>
          <Badge badgeContent={"!"} color={"info"}>
            <AssessmentOutlinedIcon />
          </Badge>
        </RoleComponentGuard>
      </>
    );
  }
  if (project.stage === Stage.NotStarted) {
    return (
      <Badge badgeContent={"!"} color={"info"}>
        <AssessmentOutlinedIcon />
      </Badge>
    );
  }
  if (project.stage === Stage.Started) {
    return (
      <Badge
        badgeContent={<DataUsageIcon sx={{ fontSize: "8px" }} />}
        color={"success"}
      >
        <AssessmentOutlinedIcon />
      </Badge>
    );
  }
}
